import { showModal } from "./modal";
export default class Form {
  constructor(form) {
		this.form = form;
  }

	submit(event) {
    const form = this.form;
    event.preventDefault();
    let btn = event.submitter;
    let modal = form.querySelector('.modal');
    let feedback = form.querySelector('.feedback');
    
    //Capture new form data
    let formdata = new FormData(form);
    formdata.append("submit", "1");
  
    // Add the button name to the form data
    formdata.append("button", btn.name);

    //Disable the save button and add "waiting" status
    btn.disabled = true;
    btn.classList.add("running");

    //Remove error styling on all fields
    form.querySelectorAll(".field, .field input, .field textarea, .field select").forEach(function (field) {
      field.classList.remove("is-invalid");
      let invalidFeedback = field.closest(".field").querySelector('.invalid-feedback');
      if(invalidFeedback) {
        invalidFeedback.remove();
      }
    });

    //Save the data
    if (formdata) {
      fetch(theme_url+'ajax/form-process.php', {
        method: 'POST',
        body: formdata,
        credentials: 'same-origin'
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.success) {
          
          if(data.redirect) {
            // If the redirect URL is returned, go there
            window.location.href = data.redirect;
          }
          else {
            //Enable save button
            setTimeout(function () {
              btn.disabled = false;
              btn.classList.remove("running");
            }, 1000);

            //Display success message
            if (modal) {
              showModal(modal,'success', data.success_header, data.success);
            }
            else if (feedback) {
              feedback.innerHTML = '<div class="alert alert-success mt-3" role="alert">' + data.success + '</div>';
            }

            if(data.reset_form) {
              //Reset the form
              form.querySelectorAll(".field").forEach(function (field) {
                field.classList.remove("focus");
                field.classList.remove("is-invalid");
                field.querySelector('input').value = null;
              });

              form.querySelectorAll("select[multiple]").forEach(function (select) {
                select.value = null;
                select.dispatchEvent(new Event('change'));
              });
            }
          }
        }
        else {
          if(Object.keys(data.errors).length > 0) {
            Object.entries(data.errors).forEach((error) => {
              let key = error[0];
              let value = error[1];
              let used_keys = [];
              form.querySelectorAll(".field [name^='" + key + "']").forEach((elem) => {
                elem.classList.add("is-invalid");
                elem.closest(".field").classList.add("is-invalid");
                if(!used_keys.includes(key)) {
                  let feedbackElem = document.createElement("p");
                  feedbackElem.classList.add("invalid-feedback");
                  feedbackElem.innerHTML = value;
                  elem.closest(".field").appendChild(feedbackElem);
                  used_keys.push(key);
                }
              });

            });
            if (modal) {
              if (data.errors.dummy) {
                showModal(modal,data.error_format, data.error_header, data.errors.dummy);
              }
              else {
                showModal(modal,data.error_format, data.error_header, 'We couldn\'t submit this form.  Please correct the marked fields and try again.');
              }
            }
            else if (feedback) {
              if (data.errors.dummy) {
                feedback.innerHTML = '<div class="alert alert-danger mt-3" role="alert">' + data.errors.dummy + '</div>';
              }
            }
          }
        }

        //Enable save button
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('running');
        });
      });
    }
  }
}